import * as actionTypes from './actionsTypes';

export const setDefaultAddNewAccount = (addNewAccountToUsers) => {
  return {
    type: actionTypes.SETDEFAULTADDNEWACCOUNT,
    data: addNewAccountToUsers,
  };
};